/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Customproduktlekodefault4Inputs */

const de__field_customproduktlekodefault4 = /** @type {(inputs: _Field_Customproduktlekodefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt-Leko-Bedarf Startwert`)
};

/**

* @param {_Field_Customproduktlekodefault4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_customproduktlekodefault4 = /** @type {((inputs?: _Field_Customproduktlekodefault4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Customproduktlekodefault4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_customproduktlekodefault4(inputs)
});
export { _field_customproduktlekodefault4 as "_field_customProduktLeKoDefault" }